import { create, el } from "@dhx/ts-common/dom";
import { View } from "@dhx/ts-common/view";
import { Popup } from "@dhx/ts-popup";
import { ILabel } from "../../types";
import { Position } from "@dhx/ts-common/html";

export class Label extends View {
	public config: ILabel;
	protected _handlers: any;
	protected _helper: Popup;
	constructor(container: HTMLElement | string, config = {}) {
		super(container, config);

		this._handlers = {
			showHelper: e => {
				e.preventDefault();
				e.stopPropagation();
				this._helper.show(e.target, {mode: this.config.labelInline ? Position.right : Position.bottom});
			},
			...this._getHandlers()
		};
		const render = () => this._draw();
		this.mount(container, create({ render }));
	}
	protected _getHandlers() {
		return {};
	}
	protected _init() {
		return;
	}

	protected _draw() {
		return this._drawLabel();
	}
	protected _drawLabel() {
		if (this.config.help) {
			if (this._helper) {
				this._helper.attachHTML(this.config.help);
			} else {
				this._helper = new Popup({css: "dhx_tooltip dhx_tooltip--forced dhx_tooltip--light"});
				this._helper.attachHTML(this.config.help);
			}
		}
		const {	id,	labelInline, label,	labelWidth,	help } = this.config;
		const width = labelInline && labelWidth ? labelWidth : "";
		return el("label.dhx_label", {
				for: id || this._uid,
				style: {minWidth: width, maxWidth: width},
				class: help ? "dhx_label--with-help" : ""
			}, help ? [
				el("span.dhx_label__holder", label),
				el("span.dhx_label-help.dxi.dxi-help-circle-outline", {
					tabindex: "0",
					role: "button",
					onclick: this._handlers.showHelper
				}),
			] : label);
	}
}
